import { render, staticRenderFns } from "./addCommondity.vue?vue&type=template&id=92bbef9c&scoped=true"
import script from "./addCommondity.vue?vue&type=script&lang=js"
export * from "./addCommondity.vue?vue&type=script&lang=js"
import style0 from "./addCommondity.vue?vue&type=style&index=0&id=92bbef9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bbef9c",
  null
  
)

export default component.exports